import { Button } from '@mui/material'
import { MarkInvoiceAsPastDueCommand } from '../../GeneratedClients/FreeBillApi';
import { useNotify, useRefresh, useTranslate } from 'react-admin';
import { apiService } from '../../apiService';
import { useMutation } from "react-query";

interface IProps {
  recordIds: string[]
  userId: string
}

const InvoiceMarkInvoiceAsPastDueButton = ({recordIds, userId}: IProps) => {
  
  const translate = useTranslate()
  const notify = useNotify()
  const refresh = useRefresh()
  const { mutate, isLoading } = useMutation((command: MarkInvoiceAsPastDueCommand) => 
    apiService.InvoicesApi.markInvoiceAsPastDue({markInvoiceAsPastDueCommand: command, id: command.id!}),
    {
      onSuccess: () => {
        notify(translate("resources.invoices.notifications.invoiceStateChanged"))
        refresh()
      },
      onError: (error: any) => {
        notify(error, {type: error})
      }
    }   
  )
  const markInvoiceAsPastDue = () => { 
    recordIds.forEach(async recordId => {
      const command: MarkInvoiceAsPastDueCommand = {
        id: recordId,
        userId: userId,
      }
      mutate(command)
    })
  }

  return (
    <Button 
      disabled={isLoading} 
      size='small' 
      onClick={markInvoiceAsPastDue} 
    >
      {translate(`resources.invoices.pastDue`)}
    </Button>
  )
}

export default InvoiceMarkInvoiceAsPastDueButton